<template>
  <CCard>
    <h3 style="margin-left: 20px; margin-top: 10px">Employee List</h3>
    <CCardHeader>
      <CRow>
        <CCol>
          <CButton 
          color="primary"
          @click="employeeAdd" 
          style="float:right;margin: 10px">
          <i class="fa fa-plus"></i>
          Add Employee
          </CButton>
        </CCol>
      </CRow>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :items="items"
        :fields="columnName"
        column-filter
        table-filter
        items-per-page-select
        :items-per-page="10"
        hover
        sorter
        pagination
        clickable-rows
      >
        <div v-for="item in items" v-bind:key="item.id"></div>
        <template #id>
          <td class="py-2">
            <CButton
              color="danger"
              variant="outline"
              square
              size="sm"
              @click="employeeDelete"
              >Delete</CButton
            >
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>
<script>
import firebase from "firebase";

export default {
  name: "employeetable",
  components: {},
  data: () => {
    return {
      selected: null,
      empName: "",
      items: [],
      item: [],
      Items: [],
      id: "",
      itemsvaluee: "",
      selectedUser: {},
      isNew: true,
      isSubmit: false,
      itemdelete: null,
      userId: "",
      columnName: [
        {
          key: "empName",
          label: "Name",
        },
        {
          key: "role",
          label: "Role",
        },
        {
          key: "id",
          label: "",
          _style: "width:1%",
          sorter: false,
          filter: false,
        },
      ],
    };
  },
  methods: {
    employeeAdd() {
      var app = this;
      app.$router.push("/employeelist");
    },
    employeeDelete() {
      const db = firebase.firestore();
      db.collection("employeeList")
        .doc(this.id)
        .delete()
        .then(() => {
          this.selectedUser = {};
          console.log("Employee successfully deleted!");
        })
        .catch(function (error) {
          console.error("Error removing document: ", error);
        });
    },
    getEmployeeList() {
      const db = firebase.firestore();
      db.collection("employeeList")
        // .where("id", "==", firebase.auth().currentUser.uid)
        // .orderBy("name")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(doc.data());
            this.id = doc.id;
            this.datavalue = {
              userid: doc.id,
              empName: doc.data().empName,
            };
            console.log(this.datavalue);
            this.items.push(this.datavalue);
          });
        });
    },
  },
  created: function () {
    this.getEmployeeList();
  },
};
</script>
<style>
</style>
